import { createContext } from 'react'

/**
 * The feature flag map.
 *
 * We want to support any string key mapping to a boolean or empty, but we
 * don't want to specify the keys (as those are determined by the server)
 */
export type FeatureFlagMap = Partial<Record<string, boolean>>

/**
 * Context containing the feature flags
 */
export const FeatureContext = createContext<FeatureFlagMap>({})
